import { Text, View, Image } from "@react-pdf/renderer";
import amlReportStyles from "../Styles/amlReportStyles";
import theme from "../../../../../css/WhiteLabelledDocuments/theme";
import CloseCircleFilled from "./../Assets/Icons/closeCircleFilled";
import CheckCircleFilled from "./../Assets/Icons/checkCircleFilled";
import capitalizeFirst from "../../Checks/utils/factories/capitalise";
import dayjs from "dayjs";
import { getCountryName } from "../../CheckDetails/Utils/getCountryName";
import { useEffect, useState } from "react";
import { getHighRiskCountries } from "../../CheckDetails/Utils/getHighRiskCountries";
import { formatDocumentType } from "../../CheckDetails/Utils/formatDocumentType";

const BioAndDocVerification = ({
  check,
  portrait,
  docFront,
  docBack,
  checkType,
}) => {
  const idVerification = [
    { a: "First Name", b: check?.verification?.person?.firstName || "" },
    { a: "Last Name", b: check?.verification?.person?.lastName || "" },
    {
      a: "Date of Birth",
      b: check?.verification?.person?.dateOfBirth
        ? dayjs(check.verification.person.dateOfBirth).format("DD MMM YYYY")
        : "",
    },
    {
      a: "Address",
      b: check?.verification?.person?.addresses
        ? check.verification.person.addresses
            .map((addr) => addr.fullAddress) // or any **string** formatting you want
            .join("\n")
        : "",
    },
    {
      a: "Document Country",
      b: getCountryName(check?.verification?.document?.country) || "",
    },
    {
      a: "Document Type",
      b: formatDocumentType(check?.verification?.document?.type) || "",
    },
    { a: "Document Number", b: check?.verification?.document?.number || "" },
    {
      a: "Date of Issue",
      b: check?.verification?.document?.validFrom
        ? dayjs(check.verification.document.validFrom).format("DD MMM YYYY")
        : "",
    },
    {
      a: "Date of Expiry",
      b: check?.verification?.document?.validUntil
        ? dayjs(check.verification.document.validUntil).format("DD MMM YYYY")
        : "",
    },
  ];

  const [highRiskCountries, setHighRiskCountries] = useState([]);

  useEffect(() => {
    async function load() {
      const list = await getHighRiskCountries();
      setHighRiskCountries(list);
    }
    load();
  }, []);

  const docCountry = check?.verification?.document?.country || "";
  const isHighRisk = highRiskCountries.includes(docCountry);

  return check?.verification ? (
    <View style={amlReportStyles.section}>
      <View style={amlReportStyles.headingRow}>
        <Text style={amlReportStyles.amlTextHeading}>
          {/* Biometric and Document Verification */}
          {checkType.toLowerCase() === "enhanced"
            ? "Biometric and Document Verification"
            : "Document Verification"}
        </Text>
        <View
          style={{
            ...amlReportStyles.checkDetailsRow,
            gap: 8,
            alignItems: "center",
          }}
        >
          {check?.verification?.status?.toLowerCase() === "declined" ? (
            <CloseCircleFilled size={20} />
          ) : check?.verification?.status?.toLowerCase() === "approved" ? (
            <CheckCircleFilled size={20} />
          ) : null}
          <Text
            style={{
              ...amlReportStyles.amlTextSubheading,
              color:
                check?.verification?.status?.toLowerCase() === "approved"
                  ? theme.colors.Success
                  : check?.verification?.status?.toLowerCase() === "declined"
                    ? theme.colors.error
                    : theme.colors.Grey400,
            }}
          >
            {capitalizeFirst(check?.verification?.status) || "Not Started"}
          </Text>
        </View>
      </View>
      {isHighRisk && (
        <View style={{ ...amlReportStyles.warningContainer }}>
          <Text
            style={{
              ...amlReportStyles.amlTextCaption,
            }}
          >
            This document has been issued by a designated High Risk Country.
          </Text>
        </View>
      )}
      {check?.verification?.reason && (
        <View
          style={{
            ...amlReportStyles.reasonContainer,
          }}
        >
          <Text
            style={{
              ...amlReportStyles.amlTextCaption,
            }}
          >
            {
              //   check?.verification?.reason.toLowerCase() ===
              // "suspicious behaviour"
              //   ? "Suspicious behaviour, this is probably because a scan has been used instead of a photograph."
              //   :
              check?.verification?.reason || ""
            }
          </Text>
        </View>
      )}
      <View
        style={{
          ...amlReportStyles.table,
          borderColor:
            check?.verification?.status?.toLowerCase() === "approved"
              ? theme.colors.Success
              : check?.verification?.status?.toLowerCase() === "declined"
                ? theme.colors.error
                : theme.colors.Grey400,
        }}
      >
        {/* Data rows */}
        {idVerification.map((row, idx) => (
          <View
            style={{
              ...amlReportStyles.tableRow,
              backgroundColor:
                idx % 2 === 0
                  ? theme.colors.White
                  : check?.verification?.status?.toLowerCase() === "approved"
                    ? theme.colors.Green400
                    : check?.verification?.status?.toLowerCase() === "declined"
                      ? theme.colors.Red400
                      : theme.colors.Grey10,
            }}
            key={idx}
            wrap={false}
          >
            <Text
              style={{
                ...amlReportStyles.tableCell,
                ...amlReportStyles.amlTextCaption,
                flex: 1,
              }}
            >
              {row.a}
            </Text>
            <Text
              style={{
                ...amlReportStyles.tableCell,
                ...amlReportStyles.amlTextValue,
                color: theme.colors.Black,
                flex: 3,
              }}
            >
              {row.b}
            </Text>
          </View>
        ))}
      </View>
      <View style={amlReportStyles.verticalSizeBox} />
      {(portrait || docFront || docBack) && (
        <Text style={amlReportStyles.amlTextHeading}>Session Media</Text>
      )}
      <View style={{ ...amlReportStyles.checkDetailsRow }}>
        {portrait && (
          <>
            <View
              style={{
                ...amlReportStyles.checkDetailsColumn,
                gap: 8,
                alignItems: "left",
                justifyContent: "flex-start",
              }}
            >
              <Text
                style={{
                  ...amlReportStyles.amlTextSubheading,
                }}
              >
                Portrait
              </Text>
              <Image src={portrait} style={amlReportStyles.mediaImage} />
            </View>
            <View style={{ ...amlReportStyles.verticalDivider }} />
          </>
        )}
        {docFront && (
          <>
            <View
              style={{
                ...amlReportStyles.checkDetailsColumn,
                gap: 8,
                alignItems: "left",
                justifyContent: "flex-start",
              }}
            >
              <Text
                style={{
                  ...amlReportStyles.amlTextSubheading,
                }}
              >
                Document Front
              </Text>
              <Image src={docFront} style={amlReportStyles.mediaImage} />
            </View>
            <View style={{ ...amlReportStyles.verticalDivider }} />
          </>
        )}
        {docBack && (
          <>
            <View
              style={{
                ...amlReportStyles.checkDetailsColumn,
                gap: 8,
                alignItems: "left",
                justifyContent: "flex-start",
              }}
            >
              <Text
                style={{
                  ...amlReportStyles.amlTextSubheading,
                }}
              >
                Document Back
              </Text>
              <Image src={docBack} style={amlReportStyles.mediaImage} />
            </View>
          </>
        )}
      </View>
    </View>
  ) : null;
};

export default BioAndDocVerification;
